/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_BackInputs */



/**
* | output |
* | --- |
* | "Back to Practice" |
*
* @param {Practice_BackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_back = /** @type {((inputs?: Practice_BackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_BackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Terug naar Oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à S'entraîner")
	return /** @type {LocalizedString} */ ("Back to Practice")
});